import { createActionHelpers } from 'vuex-loading';
import * as type from '../mutation-types';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const state = {
    searchMeta: null,
    filters: [],
    royaltyList: [],
    tierList: [],
    stateList: [],
    lastQuery: null,
};

const getters = {
    filters(state) {
        return state.filters;
    },
};

const mutations = {
    setSearchMeta(state, meta) {
        state.searchMeta = meta;
    },

    setFilters(state, filters) {
        console.log('setfilters');
        state.filters = filters;
    },

    setRoyaltyList(state, royaltyList) {
        state.royaltyList = royaltyList;
    },

    setTierList(state, data) {
        state.tierList = data;
    },

    setStateList(state, data) {
        state.stateList = data;
    },

    setLastQuery(state, query) {
        state.lastQuery = query;
    },

    [type.ADD_ASSIGN_STATION](state, royalty) {
        state.royaltyList.push(royalty);
    },
};

const actions = {
    getTierListIfNecessary({ commit, dispatch }, params = {}) {
        if (!state.tierList.length || state.lastQuery != params.query) {
            return dispatch('getTierList', params);
        }

        return Promise.resolve(state.tierList);
    },

    getTierList({ commit, dispatch }, params) {
        let options = {
            params: _.merge(
                {
                    limit: 100,
                    query: null,
                },
                params,
            ),
        };

        startLoading(dispatch, 'fetch-station-list');

        return axios
            .get(Laroute.route('franchise.vue.tiers'), options)
            .then(res => {
                let data = res.data.data;

                commit('setTierList', data);
                commit('setLastQuery', options.params.query);
                endLoading(dispatch, 'fetch-station-list');

                return data;
            })
            .catch(err => {
                endLoading(dispatch, 'fetch-station-list');
                throw err;
            });
    },

    getStateListIfNecessary({ commit, dispatch }, params = {}) {
        if (!state.stateList.length || state.lastQuery != params.query) {
            return dispatch('getStateList', params);
        }

        return Promise.resolve(state.stateList);
    },

    getStateList({ commit, dispatch }, params) {
        let options = {
            params: _.merge(
                {
                    limit: 100,
                    query: null,
                },
                params,
            ),
        };

        startLoading(dispatch, 'fetch-state-list');

        return axios
            .get(Laroute.route('franchise.vue.states'), options)
            .then(res => {
                let data = res.data.data;

                commit('setStateList', data);
                commit('setLastQuery', options.params.query);
                endLoading(dispatch, 'fetch-state-list');

                return data;
            })
            .catch(err => {
                endLoading(dispatch, 'fetch-state-list');
                throw err;
            });
    },

    getRoyaltyList({ commit, dispatch }) {
        startLoading(dispatch, 'get-royaltylist');

        return axios
            .post(Laroute.route('franchise.reports.royalty.search'), {
                filters: state.filters,
                offset: 0,
                sortField: null,
            })
            .then(res => {
                let data = res.data;

                commit('setRoyaltyList', data.output);
                endLoading(dispatch, 'get-royaltylist');

                return data;
            })
            .catch(err => {
                endLoading(dispatch, 'get-royaltylist');
                throw err;
            });
    },

    getSearchMeta({ commit, dispatch }) {
        startLoading(dispatch, 'get-royaltymeta');

        return axios
            .get(Laroute.route('franchise.royalty.search.meta'))
            .then(res => {
                commit('setSearchMeta', res.data);
                endLoading(dispatch, 'get-royaltymeta');
                return res.data;
            })
            .catch(err => {
                endLoading(dispatch, 'get-royaltymeta');
                throw err;
            });
    },

    getSearchOutlet({ commit, dispatch }) {
        startLoading(dispatch, 'get-royaltymeta');

        return axios
            .get(Laroute.route('franchise.royalty.search.outlet'))
            .then(res => {
                commit('setSearchMeta', res.data);
                endLoading(dispatch, 'get-royaltymeta');
                return res.data;
            })
            .catch(err => {
                endLoading(dispatch, 'get-royaltymeta');
                throw err;
            });
    },

    getSearchTier({ commit, dispatch }) {
        startLoading(dispatch, 'get-royaltymeta');

        return axios
            .get(Laroute.route('franchise.royalty.search.tier'))
            .then(res => {
                commit('setSearchMeta', res.data);
                endLoading(dispatch, 'get-royaltymeta');
                return res.data;
            })
            .catch(err => {
                endLoading(dispatch, 'get-royaltymeta');
                throw err;
            });
    },

    getSearchStation({ commit, dispatch }) {
        startLoading(dispatch, 'get-royaltymeta');

        return axios
            .get(Laroute.route('franchise.royalty.search.station'))
            .then(res => {
                commit('setSearchMeta', res.data);
                endLoading(dispatch, 'get-royaltymeta');
                return res.data;
            })
            .catch(err => {
                endLoading(dispatch, 'get-royaltymeta');
                throw err;
            });
    },

    createAssignStation({ commit, dispatch }, station) {
        let route = Laroute.route('franchise.royalty.station.store');
        startLoading(dispatch, 'tier-station-saved');

        return axios
            .post(route, station)
            .then(res => {
                commit(type.ADD_ASSIGN_STATION, res.data);
                endLoading(dispatch, 'tier-station-saved');

                return res;
            })
            .catch(err => {
                endLoading(dispatch, 'tier-station-saved');
                throw err;
            });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/royalty.js